import React, { useEffect, useState } from "react";
import "./PaymentPending.css";

export default function PaymentPending(){

  const [loading,setLoading] = useState(true);
  const [pedido,setPedido] = useState(null);

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  useEffect(()=>{

    const params = new URLSearchParams(window.location.search);

    const pedido_id = params.get("external_reference");
    const status = params.get("status");

    setPedido(pedido_id);

    if(!pedido_id){
      setLoading(false);
      return;
    }

    fetch(SCRIPT_URL,{
      method:"POST",
      body:new URLSearchParams({
        pedido_id:pedido_id,
        status:status || "pending"
      })
    })
    .then(()=>setLoading(false))
    .catch(()=>setLoading(false));

  },[]);


  return(

    <div className="payment-pending-page">

      <div className="payment-pending-card">

        <div className="icon-pd">
          ⏳
        </div>

        <h1>Pagamento em processamento</h1>

        <p>
          Estamos aguardando a confirmação do seu pagamento.
        </p>

        {pedido && (
          <p className="pedido">
            Pedido: <strong>{pedido}</strong>
          </p>
        )}

        {loading && (
          <div className="loader"/>
        )}

        {!loading && (
          <p className="status">
            Assim que o pagamento for confirmado você receberá a confirmação via WhatsApp.
          </p>
        )}

        <button
          className="btn"
          onClick={()=>window.location.href="/"}
        >
          Voltar ao site
        </button>

      </div>

    </div>

  )

}